import {BaseAnimation} from './BaseAnimation';

export type SlideAnimationPosition='center'|'up'|'down'|'left'|'right';

export class SlideAnimation extends BaseAnimation {

    private fromPosition:SlideAnimationPosition='center';
    private toPosition:SlideAnimationPosition='center';

    public getClass():string {
        return 'slide-animation';
    }

    private set(el:JQuery,pos:SlideAnimationPosition,amount:string|number|null=null) {
        let str;
        switch(pos) {
            case 'center': {
                if (amount!==null) throw 'amount argument not supported with center';
                el.css('transform','translate(0,0)');
                break;
            }
            case 'up': {
                str=this.px(amount??'100vh');
                el.css('transform','translate(0,-'+str+')');
                break;
            }
            case 'down': {
                str=this.px(amount??'100vh');
                el.css('transform','translate(0,'+str+')');
                break;
            }
            case 'left': {
                str=this.px(amount??'100vw');
                el.css('transform','translate(-'+str+',0)');
                break;
            }
            case 'right': {
                str=this.px(amount??'100vw');
                el.css('transform','translate('+str+',0)');
                break;
            }
        }
    }

    public after() {
        super.after();
        if (this.toPosition=='center') {
            this.element.css('transform','none');
        }
    }

    public from(pos:SlideAnimationPosition,amount:string|number|null=null) {
        this.fromPosition=pos;
        this.set(this.fromItem,pos,amount);
        return this;
    }

    public to(pos:SlideAnimationPosition,amount:string|number|null=null) {
        this.toPosition=pos;
        this.set(this.toItem,pos,amount);
        return this;
    }

}

export {};